import React, { PureComponent } from 'react';
import debug from 'utils/debug';

import Row from './Row';

const { METHOD } = debug('c:ModalWindow:TableView:Window');

class ModalWindow extends PureComponent {
  state = {};

  render() {
    METHOD('render', { props: this.props });

    return (
      <React.Fragment>
        <Row />
      </React.Fragment>
    );
  }
}

export default ModalWindow;
